import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, OrganizationResponseData } from "schema"
import { z } from "zod"

type OrganizationResponse = DataResponse<z.infer<typeof OrganizationResponseData>>

export const getOrganizationQuery = () => {
  return queryOptions({
    queryKey: ["organization"],
    queryFn: async () => {
      const { data } = await axios.get<OrganizationResponse>("/organizations")

      return data.data
    },
    retry: 0,
  })
}
